import axios from 'axios';

export const channelsRequest = (tipsterID: string) =>
  axios.get(`v1/spaces/${tipsterID}/channels`);
